import { render, staticRenderFns } from "./ChartRehabContainerSideHopGeneralParameters.vue?vue&type=template&id=823ec3c6&scoped=true&"
import script from "./ChartRehabContainerSideHopGeneralParameters.vue?vue&type=script&lang=ts&"
export * from "./ChartRehabContainerSideHopGeneralParameters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823ec3c6",
  null
  
)

export default component.exports